import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function getField(database, recordKey, columnKey) {
  var record = database.getRecord(recordKey);
  return record ? record.fields[columnKey] : null;
}

function getFieldKey(database, recordKey, columnKey) {
  return "".concat(recordKey, "-").concat(columnKey);
}

var fieldDefaultData = {};

function getFieldData(database, recordKey, columnKey) {
  var field = getField(database, recordKey, columnKey);
  return field ? field.data : fieldDefaultData;
}

function mergeFieldData(database, recordKey, columnKey, data) {
  var activeSort = database.getActiveSort();

  if (activeSort && activeSort.columnKey === columnKey) {
    database.setFrozenOrder();
  }

  database.applyAction({
    type: 'mergeFieldData',
    payload: {
      recordKey: recordKey,
      columnKey: columnKey,
      currentUserId: database.currentUserId,
      data: data
    }
  });
}

function updateFieldData(database, recordKey, columnKey) {
  var updateFn = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (x) {
    return x;
  };
  var prevData = getFieldData(database, recordKey, columnKey);
  var newData = updateFn(prevData);
  mergeFieldData(database, recordKey, columnKey, newData);
}

function deleteActiveField(database) {
  var _database$getActiveKe = database.getActiveKeys(),
      _database$getActiveKe2 = _slicedToArray(_database$getActiveKe, 2),
      recordKey = _database$getActiveKe2[0],
      columnKey = _database$getActiveKe2[1];

  database.deleteField(recordKey, columnKey);
}

function deleteSelectedFields(database) {
  var _database$getSelectio = database.getSelection(),
      selectedKeys = _database$getSelectio.selectedKeys,
      activeKey = _database$getSelectio.activeKey;

  var selectionKeysToDelete = selectedKeys.length === 0 ? [activeKey] : selectedKeys;
  selectionKeysToDelete.forEach(function (selectionKey) {
    var _database$getActiveKe3 = database.getActiveKeys(),
        _database$getActiveKe4 = _slicedToArray(_database$getActiveKe3, 2),
        recordKey = _database$getActiveKe4[0],
        columnKey = _database$getActiveKe4[1];

    if (recordKey !== 'header') {
      database.deleteField(recordKey, columnKey);
    }
  });
}

function deleteField(database, recordKey, columnKey) {
  database.applyAction({
    type: 'deleteField',
    payload: {
      recordKey: recordKey,
      columnKey: columnKey
    }
  });
}

export default {
  commands: {
    deleteField: deleteField,
    deleteSelectedFields: deleteSelectedFields,
    deleteActiveField: deleteActiveField,
    mergeFieldData: mergeFieldData,
    updateFieldData: updateFieldData
  },
  queries: {
    getField: getField,
    getFieldKey: getFieldKey,
    getFieldData: getFieldData
  }
};